import "pfkl-vselect/vselect/vselect.min.js";

jQuery(function ($) {
  if ($(".multimedia-media-item").length <= 0) { return; }
  
  console.log("mmreport.js Ready");

  const mediaItems = $(".multimedia-media-item");
  const yearSelects = $(".mmreport-vselect.year");
  const fromYearSelect = $("#mmm-from-year-select");
  const toYearSelect = $("#mmm-to-year-select");
  const regionSelect = $("#mmm-region-select");
  const applyButton = $("#mmreport-media-filter-apply");
  const resetButton = $("#mmreport-media-filter-reset");
  const pagination = $(".pagination");
  const pageIndex = $(".page-index");
  const prevButton = $("#mmreport-media-prev");
  const nextButton = $("#mmreport-media-next");
  const noPostMsg = $("#no-post-message");
  const loading = $('#mmreport-media-loading');

  // Gather year values
  let minYear;
  let maxYear;
  let years = [];
  let regions = [];
  let currentPage = 1;
  let totalPage = 0;
  const itemsPerPage = 8;

  function init() {
    // Get years, region ids and region names from media item elements
    mediaItems.each(function (index) {
      const item = $(this);
      const year = item.data("year");
      const regionId = item.data("region-id");
      const regionName = item.data("region-name");

      if (year !== undefined && !years.includes(year)) {
        years.push(year);
      }

      const region = {
        id: regionId,
        name: regionName,
      };

      if (regionId !== "" && regionId !== undefined) {
        if (
          !regions.find((region, index) => {
            return region.id === regionId;
          })
        ) {
          regions.push(region);
        }
      }
    });

    // Sort years in ASC order
    if (years.length > 0) {
      years.sort(function (a, b) {
        return a - b;
      });

      minYear = years[0];
      maxYear = years[years.length - 1];
    }

    // Sort regions in ASC order
    regions.sort(function (a, b) {
      return a.name - b.name;
    });

    // Populate years select list options
    yearSelects.each(function () {
      const elm = $(this);

      $.each(years, (index, year) => {
        elm.append('<option value="' + year + '">' + year + "</option>");
      });
    });

    // Populate regions select list options
    $.each(regions, (index, region) => {
      regionSelect.append(
        '<option value="' + region.id + '">' + region.name + "</option>"
      );
    });

    // Show only first page of active items
    processActiveItems();

    // Init vSelect
    $(".mmreport-vselect").each(function () {
      const s = $(this);
      let settings = {
        multiSelect: false,
        search: false,
        display: "values",
      };

      if (s.data("placeholder") !== undefined) {
        settings.placeholder = s.data("placeholder");
      }

      settings.onChange = function (values, options) {
        console.log("values", values);
      };

      s.vSelect(settings);
    });
  }

  function processActiveItems(page = 1) {
    loading.show();

    // No active items from current filters selection
    if ($(".multimedia-media-item.active").length <= 0) {
      mediaItems.hide();
      pagination.hide();
      noPostMsg.show();

      return;
    }

    noPostMsg.hide();

    const startIndex = page * itemsPerPage - itemsPerPage;
    const endIndex = startIndex + (itemsPerPage - 1);

    $(".multimedia-media-item").hide();
    // $(".multimedia-media-item").css('background-color', 'red');

    // Display active items on current page
    $(".multimedia-media-item.active").each(function (index) {
      if (index >= startIndex && index <= endIndex) {
        $(this).show();
        // $(this).css('background-color', 'green');
      }
    });

    // Update pagination page index
    currentPage = page;
    totalPage = Math.ceil(
      $(".multimedia-media-item.active").length / itemsPerPage
    );
    pageIndex.text(page + " of " + totalPage);
    pagination.show();

    setTimeout(() => {
      loading.fadeOut();
    }, 500);
  }

  function applyFilters() {
    const fromYear = fromYearSelect.val();
    const toYear = toYearSelect.val();
    const region = regionSelect.val();

    if (fromYear === "" && toYear === "" && region === "") {
      resetButton.trigger('click');
      resetButton.hide();
      return;
    }

    resetButton.show();

    let yearTags = [];

    // Either from year or to year is selected
    if (fromYear !== "" || toYear !== "") {
      let c;
      let e;

      // Both from and to year is selected
      if (fromYear !== "" && toYear !== "") {
        if (fromYear > toYear) {
          $(".mmreport-media-filter-error").text(
            "Invalid year filter seletion!"
          );

          return;
        }

        c = parseInt(fromYear);
        e = parseInt(toYear);
      } else {
        // When only from year is selected, set to year to max year
        if (fromYear !== "") {
          c = fromYear;
          e = maxYear;
        } else {
          // When only to year is selected, set from year to min year
          c = minYear;
          e = toYear;
        }
      }

      // year class to filter array
      yearTags.push("year-" + String(c));

      while (c < e) {
        c++;
        yearTags.push("year-" + String(c));
      }
    }

    // Years filter is available
    if (yearTags.length > 0) {
      $(".multimedia-media-item").removeClass("active");

      $.each(yearTags, (index, year) => {
        $(
          ".multimedia-media-item." +
            year +
            (region !== "" ? ".region-" + region : "")
        ).addClass("active");
      });

      processActiveItems();
    } else if (region !== "") {
      // Only region filter is selected
      $(".multimedia-media-item").removeClass("active");
      $(".multimedia-media-item.region-" + region).addClass("active");

      processActiveItems();
    }
  }

  // Go to previous page
  prevButton.on("click", function () {
    if (currentPage === 1) {
      return;
    }

    currentPage--;
    processActiveItems(currentPage);
  });

  // Go to next page
  nextButton.on("click", function () {
    if (currentPage >= totalPage) {
      return;
    }

    currentPage++;
    processActiveItems(currentPage);
  });

  // Apply selected filters
  applyButton.on("click", function () {
    applyFilters();
  });

  resetButton.on('click', function () {
    fromYearSelect.data('vSelect').resetOptions();
    toYearSelect.data('vSelect').resetOptions();
    regionSelect.data('vSelect').resetOptions();

    mediaItems.addClass('active');
    processActiveItems();

    $(this).hide();
  })

  init();

  $('#mmreport-media-wrapper').removeClass('invisible');
  loading.fadeOut();
});
